var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAccount = function SvgIconAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 20C4.482 20 0 15.523 0 10S4.482 0 10 0c5.53 0 10 4.477 10 10s-4.47 10-10 10m0-18c-4.422 0-8 3.582-8 8 0 2.145.843 4.094 2.217 5.53a5.05 5.05 0 0 1 2.35-2.897A4.99 4.99 0 0 1 5 9.001C5 6.238 7.241 4 10 4s5 2.238 5 5c0 1.43-.602 2.721-1.566 3.633a5 5 0 0 1 2.35 2.897A7.98 7.98 0 0 0 18 10c0-4.418-3.578-8-8-8m4 14.93A2.996 2.996 0 0 0 11 14H9a3.004 3.004 0 0 0-3 2.93A8 8 0 0 0 10 18c1.458 0 2.82-.389 4-1.07M10 12c1.663 0 3-1.343 3-3a2.997 2.997 0 0 0-3-3C8.35 6 7 7.343 7 9s1.35 3 3 3",
    className: "icon_account_svg__nav-icon"
  })));
};
export default SvgIconAccount;